import { throwError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AppSettingService } from 'src/app/services/app-setting.service';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AddressService
{

  constructor(private http: HttpClient) { }
  error(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(error);
    return throwError(errorMessage);
  }

  
  updateAddress(model: any,addressType:any):Observable<any> {
    model.AddressType=addressType;
    return this.http.post(AppSettingService.addProviderAddressUri, (model)).pipe(catchError(this.error))

  }
  updateMailingAddress(model: any):Observable<any> {
    return this.http.post(AppSettingService.updatemailingaddressUri, (model)).pipe(catchError(this.error))

  }
  
  getMailingAddress():Observable<any> {
    return this.http.get(AppSettingService.getmailingaddressUri).pipe(catchError(this.error))

  }
}